import axios from "axios";

const urlPath = "trabajador";

export const getTrabajadores = async (nif) => {
  try {
    const response = await axios.get(`${urlPath}/get/${nif}`);
    return response.data;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};

export const addTrabajador = async (nif, data) => {
  try {
    const response = await axios.post(`${urlPath}/add/${nif}`, data);
    return response.data;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};

  export const eliminarTrabajador = async (nifSupp, ids) => {
    try {
      const response = await axios.post(`${urlPath}/delete/${nifSupp}`, { ids });
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  export const eliminarDocumento = async (nifSupp, idTrabajador, tipoDoc) => {
    try {
      const response = await axios.delete(`${urlPath}/deleteDocumento/${nifSupp}/${idTrabajador}/${tipoDoc}`);
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  export const actualizarTrabajador = async (id, data) => {
    try {
      const response = await axios.put(`${urlPath}/update/${id}`, data);
      return response.data;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  export const subirDocumento = async (nifSupp, idTrabajador, formData) => {
    try {
      const response = await axios.post(`${urlPath}/upload/${nifSupp}/${idTrabajador}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  export const validarDocumento = async (nifSupp, idTrabajador, tipoDoc, body) => {
    try {
      const response = await axios.post(`${urlPath}/validar/${nifSupp}/${idTrabajador}/${tipoDoc}`, body);
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  export const gestionarBajaMedica = async (nifSupp, idTrabajador, tipoDoc, data) => {
    try {
      const response = await axios.post(`${urlPath}/bajaMedica/${nifSupp}/${idTrabajador}/${tipoDoc}`, data);
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  export const gestionarNoProcede = async (nifSupp, idTrabajador, tipoDoc, data) => {
    try {
      const response = await axios.post(`${urlPath}/noProcede/${nifSupp}/${idTrabajador}/${tipoDoc}`, data);
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  export const plantillaTrabajadorProveedor = async (formData) => {
    try {
      const response = await axios.post(`${urlPath}/upload/xlsx`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };
